// index.tsx
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Provider } from 'react-redux';
import store from './data/store';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const debounce = (callback: Function, delay: number) => {
  let tid: NodeJS.Timeout;
  return function (...args: any[]) {
    clearTimeout(tid);
    tid = setTimeout(() => callback(...args), delay);
  };
};

const resizeObserverLoopErrRe = /^[^(ResizeObserver loop limit exceeded)]/;
const resizeObserverLoopErr = debounce((e: ErrorEvent) => {
  if (resizeObserverLoopErrRe.test(e.message)) {
    const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
    if (resizeObserverErr) {
      resizeObserverErr.style.display = 'none';
    }
  }
}, 100);

window.addEventListener('error', resizeObserverLoopErr);

root.render(
  <GoogleOAuthProvider clientId={`${process.env.REACT_APP_GOOGLE_AUTH}`}>
    <StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </StrictMode>
  </GoogleOAuthProvider>
);

reportWebVitals();